import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import styled from '@emotion/styled'
import { useSelector, useDispatch } from 'react-redux'

import { postFrontUserBookmark } from 'api'
import { deleteWishlist } from 'store/wishlist'
import { FavoriteFill } from '../common/icon/Favorite'
import Star from 'components/common/icon/Star'
import BuyNow from 'components/common/icon/BuyNow'
import { BLUR, HOST, TAIL } from 'constants/image'

const WishlistCard = ({ data, state, setState, t }) => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)

  const {
    store_id,
    store_image,
    translate_store_name,
    translate_branch_name,
    rti_star,
    show_cnt,
    product_id,
    translate_product_name,
    translate_store_label_name,
    product_price,
    currency,
    product_sale_status,
    s_category,
  } = data

  const removeBookmark = (e) => {
    e.preventDefault()
    const type = product_id ? 'product' : 'store'

    if (type === 'store') {
      setState(state.filter((e) => e.store_id !== store_id))
      dispatch(deleteWishlist({ wishlist: store_id }))
      postFrontUserBookmark({ token, store_id })
    } else {
      setState(state.filter((e) => e.product_id !== product_id))
      dispatch(deleteWishlist({ wishlist: product_id }))
      postFrontUserBookmark({ token, store_id, product_id })
    }
  }

  return (
    <Container>
      <Link
        href={
          product_id
            ? `/food/${store_id}/product/${product_id}`
            : s_category === 'tour'
            ? `/tour/${store_id}`
            : `/food/${store_id}`
        }
      >
        <ImageBox>
          <Image
            src={store_image ? `${HOST}${store_image}${TAIL}` : BLUR}
            alt=""
            width={0}
            height={0}
            sizes="100%"
            style={{
              width: '100%',
              height: 120,
              objectFit: 'cover',
              borderStartStartRadius: 5,
              borderStartEndRadius: 5,
            }}
          />
          {product_sale_status && (
            <div className="buy_now">
              <BuyNow />
            </div>
          )}
          <div onClick={(e) => removeBookmark(e)}>
            <FavoriteFill />
          </div>
        </ImageBox>

        <InfoBox>
          <div>
            <StoreName>
              {translate_store_name}
              {!translate_branch_name || translate_branch_name === ''
                ? null
                : `(${translate_branch_name})`}
            </StoreName>

            <Score style={{ dis: 'flex' }}>
              <Star />
              <span>{rti_star ?? 0}</span>
              <span>
                &nbsp;
                {show_cnt
                  ? `(${parseInt(show_cnt).toLocaleString('ko-kr')})`
                  : ` (${0})`}
              </span>
            </Score>
          </div>

          {product_id ? (
            <>
              <div>
                <ProductName>{translate_product_name}</ProductName>
                <Label>{translate_store_label_name}</Label>
                <Price>
                  {parseInt(product_price).toLocaleString('ko-kr')}{' '}
                  <span>{currency}</span>
                </Price>
              </div>

              {product_sale_status ? (
                <ProductBottom>
                  <BuyNow />
                  <Label>{t('product:pay_reserve')}</Label>
                </ProductBottom>
              ) : (
                <div style={{ height: 24 }}></div>
              )}
            </>
          ) : (
            <div style={{ height: 150 }}></div>
          )}
        </InfoBox>
      </Link>
    </Container>
  )
}

export default WishlistCard

const Container = styled.li`
  width: 100%;
  height: 340px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
`

const ImageBox = styled.div`
  position: relative;
  height: 120px;

  .buy_now {
    position: absolute;
    top: 10px;
    left: 10px;
  }
`

const InfoBox = styled.div`
  height: 220px;
  padding: 10px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const StoreName = styled.p`
  font-size: 14px;
  font-weight: 600;
`

const Score = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #777;
  margin-top: 10px;

  img {
    margin-right: 5px;
  }
`

const ProductName = styled.p`
  font-size: 14px;
  font-weight: 600;
`

const Label = styled.p`
  font-size: 12px;
  color: #777;
  margin: 5px 0;
`

const Price = styled.p`
  font-size: 16px;
  font-weight: 600;

  span {
    font-size: 12px;
    color: #777;
  }
`

const ProductBottom = styled.div`
  height: 24px;
  font-size: 12px;
  color: #777;

  display: flex;
  align-items: center;
`
